import * as React from 'react';
import { connect } from 'react-redux';
// import styled from 'styled-components';

// Components
import styled from 'styled-components';
import { AbsolutePositioned } from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { DiagonalLine, VerticalLine, HorizontalLine } from '../../../components/Layout/Line';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import Title from '../../../components/Title';
import TextBlock from '../../../components/TextBlock';
import ContactForm from '../../../components/ContactForm';
import SimpleInput from '../../../components/ContactForm/Inputs/Simple';
import TextAreaInput from '../../../components/ContactForm/Inputs/TextArea';
import Hyperlink from '../../../components/Hyperlink';
import SealAnimation from '../../../components/SealAnimation';

// Assets
import { brandColors, device } from '../../../styles/variables';
import dani from '../../../assets/images/tech-dani.jpg';

const StyledScreen = Screen.extend`
  height: 100%;
  padding: 0 0 50px 0;
  min-height: 1258px;
  @media ${device.tablet} {
    min-height: inherit;
    padding: 0;
  }
`;

const BackgroundSplitScreen = SplitScreen.extend`
  position: relative;
  background-size: cover;
  background: url(${dani}) 70% 100%;
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 39%;
  @media ${device.tablet} {
    position: relative;
    display: inline-block;
    width: 50%;
    height: 100%;
  }
`;

const BackgroundOverlay = AbsolutePositioned.extend`
  background: ${brandColors.blue};
  width: 100%;
  height: 100%;
  opacity: 0.7;
`;

const YellowSplitScreen = SplitScreen.extend`
  background: ${brandColors.yellow};
  display: block;
  width: 100%;
  height: 100%;
  @media ${device.tablet} {
    display: inline-block;
    width: 50%;
    height: 100%;
  }
`;

const ContentHolder = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
`;

const ContentSplitScreen = SplitScreen.extend`
  vertical-align: top;
  position: relative;
  width: 100%;
  float: none;
  height: auto;
  @media ${device.tablet} {
    float: right;
    width: 50%;
    height: 100%;
  }

  &.contact-form-split {
    bottom: 0;
    left: 0;
    height: 35%;
    @media ${device.tablet} {
      position: absolute;
      height: 65%;
    }
  }
`;

const TextContent = AbsolutePositioned.extend`
  min-width: 350px;
  position: relative;
  margin: 121px 0 0 0;
  @media ${device.tablet} {
    position: absolute;
    top: unset;
    margin: 0;
    left: 40px;
    bottom: 100px;
  }
  @media ${device.laptopL} {
    left: 60%;
    transform: translate(-50%);
    bottom: 100px;
  }

  .Number {
    h2 {
      color: ${brandColors.orange};
      @media ${device.laptop} {
        color: ${brandColors.blue};
      }
    }
  }
`;

const ContactFormPosition = AbsolutePositioned.extend`
  bottom: 75px;
  top: unset;
  left: 50%;
  transform: translate(-50%);
  min-width: 360px;
  @media ${device.tablet} {
    bottom: 110px;
  }
  div:first-child {
    margin: 0;
  }
`;

const SealContainer = styled.div`
  @media ${device.tablet} {
    position: relative;
    top: 0;
    left: 40px;
  }
  @media ${device.laptopL} {
    position: absolute;
    top: 295px;
  }
`;

const MainContactScreen = () => (
  <StyledScreen id="contactMain">
    <BackgroundSplitScreen>
      <BackgroundOverlay />
      <HorizontalLine />
      <SplitScreenContentHolder direction="right">
        <DiagonalLine />
        <VerticalLine />
      </SplitScreenContentHolder>
    </BackgroundSplitScreen>
    <YellowSplitScreen />
    <ContentHolder>
      <ContentContainer>
        <ContentSplitScreen>
          <SealContainer>
            <SealAnimation />
          </SealContainer>
          <TextContent className="text-content" top="unset" bottom="100px">
            <TextBlock>
              <p>
                We can&apos;t fit all of our stories in here. If you would like to find out more
                about our work or enquire about new business, use the form or call us on
              </p>
            </TextBlock>
            <br />
            <br />
            <Title className="Number" primary={false}>
              <Hyperlink
                linkName="020&nbsp;8334&nbsp;7860"
                originalColor={brandColors.blue}
                color={brandColors.orange}
                linkAddress="tel:02083347860"
              />
            </Title>
          </TextContent>
        </ContentSplitScreen>
        <ContentSplitScreen className="contact-form-split">
          <ContactFormPosition className="contact-form-position">
            <ContactForm form="primary">
              <SimpleInput name="name" text="name*" />
              <SimpleInput name="email" text="email*" />
              <SimpleInput name="subject" text="subject*" />
              <TextAreaInput name="message" text="message*" />
            </ContactForm>
          </ContactFormPosition>
        </ContentSplitScreen>
      </ContentContainer>
    </ContentHolder>
  </StyledScreen>
);

export default connect()(MainContactScreen);



// WEBPACK FOOTER //
// ./src/pages/Contact/screens/MainContact.jsx